import * as React from 'react';

export const ConstructionProgress = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="#2B87DB" fillRule="nonzero">
      <path d="M16 5V3L6 2V0H3v2L0 3v2h3v9.006H0V16h9v-1.994H6V5z" />
      <path d="M14 9.006V6h-1v3.006h-1a1 1 0 0 0-1 1V12a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1.994a1 1 0 0 0-1-1h-1z" />
    </g>
  </svg>
);
